import AccountStore, {AccountStoreTypes} from './account';
import GroupStore from './group';
import OrderStore from './Order'
import NewMachine from './NewMachine/NewMachine'
import IPService from './NewMachine/IPService'
import BuyStore from './Buy/index'
import Renewal from './Renewal'
import FlashStore from './Flash'

export interface UserStoreTypes {
  AccountStore: AccountStoreTypes;
  GroupStore: GroupStore;
  OrderStore: OrderStore;
  NewMachine: NewMachine;
  IPService: IPService;
  BuyStore: BuyStore,
  RenewalStore: Renewal,
  FlashStore:FlashStore,
}

export interface UserStoreProps {
  UserStore: UserStoreTypes;
}

const UserStore = {
  AccountStore: AccountStore,
  GroupStore: new GroupStore(),
  OrderStore: new OrderStore(),
  NewMachine: new NewMachine(),
  IPService: new IPService(),
  BuyStore: new BuyStore(),
  RenewalStore: new Renewal(),
  FlashStore:new FlashStore(),
}

export default UserStore;
